<template>
    <div class="row">
        <div class="col-4">
            <small>{{ this.$i18n.LATEST_DATA_IMPORT }} {{ dbUpdateTime }}</small>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({ timezoneOffset: (state) => state.timezoneOffset }),
        ...mapState("dataModule", { lastScriptRunStart: (state) => state.system.lastScriptRunStartUTC }),
        dbUpdateTime: function () {
            return this.lastScriptRunStart
                ? new Date(new Date(this.lastScriptRunStart + "Z").getTime() + this.timezoneOffset * 60 * 60 * 1000)
                      .toUTCString()
                      .replace("GMT", "")
                : "";
        },
    },
};
</script>
